import { RenderIf } from 'components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

export const DataTransContainer = () => {
  const isDatatransActivated = useMySelector((state) => {
    return state.app.companyData.DatatransActivated
  })
  return (
    <RenderIf condition={isDatatransActivated}>
      <div
        id="datatransContainer"
        style={{ display: 'none', height: '0px', width: '0px' }}
      />
    </RenderIf>
  )
}
